// extracted by mini-css-extract-plugin
export default {"ns_arrow_button":"SetupWizard_ns_arrow_button__c6PZ2"};